import React from "react";
import { Input } from "@arco-design/web-react";

// MUI TextField -> Arco Input. Arco's onChange passes the value directly (not an
// event). `allowClear` renders a built-in, vertically-centered clear (X) inside
// the field, replacing the old separately-positioned clear button.
function MailTextFilter({ handleSearchFilterChange, searchTerm }) {
    return (
        <Input
            value={searchTerm}
            id="search-bar"
            allowClear
            onChange={(value) => handleSearchFilterChange(value)}
            placeholder="Search..."
            style={{ width: 220 }}
        />
    );
}

export default MailTextFilter;
